import React from 'react';

import { Box } from '@mui/material';

const Page = ({ allowPrinting, children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        overflow: 'hidden',
        alignItems: 'stretch',
        // override the default page visibility of printing, when using <Print> component
        // use the "allowPrinting" prop to override this and allow printing without using the special component
        '@media print': allowPrinting ? {} : { display: 'none' }
      }}
    >
      {children}
    </Box>
  );
};

export default Page;
